Namespace 'Customer.Dashboard'

class Customer.Dashboard.TicketDetailsStatsView extends Backbone.View
  className: 'ticket-details-stats'
  template: JST['backbone/templates/customer/ticket/detail/box/ticket_details_stats']

  initialize: ({ticket, interaction}) ->
    @ticket = ticket
    @interaction = interaction
    @priorityView = new Customer.Ticket.PriorityView(model: @ticket)
    @listenTo(@priorityView, 'priority:changed', @changePriority)
    @listenTo(@ticket, 'change', @render)

  render: ->
    @$el.html(@template(ticket: @ticket))
    @priorityView.delegateEvents()
    @$el.find('#priority').html(@priorityView.render().el)
    @_renderIntegrationStats()
    @stopListening(@ticket)
    @listenTo @ticket, 'stats:loaded', @_renderStats
    @ticket.loadStats(@interaction, true)
    @

  _renderIntegrationStats: ->
    @integrationStatsView = new Customer.Dashboard.TicketDetailsStats.IntegrationsView
      ticket: @ticket
      el: @$el.find('.integrations')
    @integrationStatsView.render()

  _renderStats: =>
    @$('.responses-count').html(@ticket.getResponsesCount())
    @$('.last-response-date').html(@ticket.getLastResponseDateString())
    @_renderTicketsByUser()
    @_renderExternalTicketsByUser()

  _renderTicketsByUser: ->
    $container = @$('.tickets-by-user-container')
    return $container.html('') unless @ticket.mustShowTicketsByUser()
    @ticketsByUserView = new Customer.Ticket.InternalTicketsByUserView(ticket: @ticket)
    @listenTo(@ticketsByUserView, 'opened:relatedOpenedTickets', @onClickRelatedOpenedCount)
    @listenTo(@ticketsByUserView, 'opened:relatedClosedTickets', @onClickRelatedClosedCount)
    $container.html @ticketsByUserView.render().el

  _renderExternalTicketsByUser: ->
    $container = @$('.external-tickets-by-user-container')
    return $container.html('') unless @_shouldRenderExternalTickets()
    @externalTicketsByUserView = new Customer.Ticket.ExternalTicketsByUserView(ticket: @ticket)
    $container.html @externalTicketsByUserView.render().el

  _shouldRenderExternalTickets: ->
    Keepcon.currentAccount.customer.externalTicketsEnabled and @ticket.stats.external_tickets_in_period_count > 0

  onClickRelatedOpenedCount: ->
    Backbone.trigger('opened:relatedOpenedTickets', @ticket.id, @ticket.stats.opened_last_month_ids)

  onClickRelatedClosedCount: ->
    Backbone.trigger('opened:relatedClosedTickets', @ticket.id, @ticket.stats.closed_last_month_ids)

  changePriority:(priority)->
    @showPrioritySpinner()
    @priority = priority
    @ticket.changePriority({priority: parseInt(priority)})
    @listenTo(@ticket, 'ticket:prioritize:success', @prioritizeSucess)

  showPrioritySpinner: ->
    @$el.find('#loading-priority').show()

  hidePrioritySpinner: ->
    @$el.find('#loading-priority').hide()

  prioritizeSucess:->
    @ticket.attributes.priority = @priority
    @priorityView.prioritizeSucess(@ticket)
